"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataGrid = DataGrid;

var _loading = require("./loading");

var _styledTools = require("styled-tools");

var _styles = require("react-components/styles");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * `Rows` styled component.
 */
var Rows = _styledComponents["default"].div.attrs({
  role: 'rowgroup'
}).withConfig({
  displayName: "data-grid__Rows",
  componentId: "sc-1y7kbsl-0"
})(["display:grid;grid-row-gap:12px;grid-template-columns:1fr;position:relative;", " ", ""], _styles.media.min('ms')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-auto-rows: 1fr;\n  "]))), (0, _styledTools.ifProp)('isLoading', (0, _styledComponents.css)(["min-height:", ";", ""], (0, _styledTools.ifProp)('isText', '10vh', '30vh'), _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      min-height: ", ";\n    "])), (0, _styledTools.prop)('isText', '10vh', '50vh')))));
/**
 * Export `DataGrid` component.
 */


function DataGrid(props) {
  var children = props.children,
      className = props.className,
      emptyMessage = props.emptyMessage,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$isText = props.isText,
      isText = _props$isText === void 0 ? false : _props$isText,
      total = props.total;
  return /*#__PURE__*/_react["default"].createElement(Rows, {
    className: className,
    isLoading: isLoading,
    isText: isText
  }, total === 0 && !isLoading && emptyMessage, /*#__PURE__*/_react["default"].createElement(_loading.Loading, {
    active: isLoading
  }), !isLoading && total > 0 && children);
}